var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIaklGlobalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2010_1879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.99967C14.6666 11.6816 11.6819 14.6663 7.99998 14.6663M14.6666 7.99967C14.6666 4.31778 11.6819 1.33301 7.99998 1.33301M14.6666 7.99967H1.33331M7.99998 14.6663C4.31808 14.6663 1.33331 11.6816 1.33331 7.99967M7.99998 14.6663C9.6675 12.8408 10.6151 10.4717 10.6666 7.99967C10.6151 5.5277 9.6675 3.15858 7.99998 1.33301M7.99998 14.6663C6.33246 12.8408 5.38481 10.4717 5.33331 7.99967C5.38481 5.5277 6.33246 3.15858 7.99998 1.33301M1.33331 7.99967C1.33331 4.31778 4.31808 1.33301 7.99998 1.33301",
    stroke: "#F9FAFB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2010_1879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIaklGlobalIcon);
export default __webpack_public_path__ + "static/media/iakl-global-icon.8c1e6578.svg";
export { ForwardRef as ReactComponent };